export default {
  slider: 'slider',
  checkbox: 'checkbox',
  radio: 'radio',
  multiselect: 'hierarchical-checkbox'
}
